import React from 'react'
import { withStyles } from '@material-ui/core'

import { styles } from './styles'
import { RIBBON_BLUE } from 'constants/colors'

interface Props {
  classes: any
  imgUrl: string
  highlight: boolean
}

const ImageMessage: React.FC<Props> = props => {
  const { classes, imgUrl, highlight } = props

  return (
    <img
      style={{ backgroundImage: '/images/platform/loader.svg', border: highlight && `1px solid ${RIBBON_BLUE}` }}
      className={classes.img}
      src={imgUrl}
      alt="icon"
    />
  )
}

export default withStyles(styles)(ImageMessage)
